import React from "react";
import Footer from "../components/Partials/Footers/HomeOne/Footer";

const AboutUs = () => {
  return (
    <>
      <div className="about-us-hero">
        <div className="about-us-hero-content">
          <h1 className="about-us-hero-title">Rreth Nesh – Balotazhi</h1>
          <div className="about-us-hero-subtitle">
            Platforma e pavarur e lajmeve në gjuhën shqipe
          </div>
        </div>
      </div>

      <div className="about-us-container">
        <div className="about-us-content">
          <div className="about-us-section">
            <p className="about-us-text about-us-intro">
              Balotazhi është një platformë e pavarur dhe bashkëkohore e lajmeve
              në gjuhën shqipe, e themeluar në vitin 2025. Që nga fillimi,
              misioni ynë ka qenë i qartë: të ofrojmë informacion të saktë, të
              shpejtë dhe të besueshëm për ngjarjet që ndikojnë në jetën e
              qytetarëve tanë, kudo që ndodhen.
            </p>

            <p className="about-us-text">
              Ne besojmë se lajmi nuk është vetëm një fakt i publikuar, por një
              përgjegjësi ndaj publikut. Për këtë arsye, çdo raportim i Balotazhi
              mbështetet në verifikim të kujdesshëm të burimeve, paanshmëri
              editoriale dhe respekt për etikën profesionale të gazetarisë.
            </p>
          </div>

          <div className="about-us-section">
            <h2 className="about-us-subtitle">Çfarë na dallon</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">🔒</div>
                <div className="feature-content">
                  <h3 className="feature-title">Besueshmëria</h3>
                  <p className="feature-description">
                    Çdo lajm kalon nëpër një proces të rreptë verifikimi për të
                    garantuar saktësi.
                  </p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">⚖️</div>
                <div className="feature-content">
                  <h3 className="feature-title">Pavarësia</h3>
                  <p className="feature-description">
                    Ne nuk jemi të lidhur me interesa politike apo ekonomike që
                    mund të ndikojnë përmbajtjen tonë.
                  </p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">⚡</div>
                <div className="feature-content">
                  <h3 className="feature-title">Shpejtësia</h3>
                  <p className="feature-description">
                    Raportim në kohë reale duke përdorur teknologjitë më të
                    fundit.
                  </p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">📚</div>
                <div className="feature-content">
                  <h3 className="feature-title">Larmia e përmbajtjes</h3>
                  <p className="feature-description">
                    Nga politika dhe ekonomia, tek kultura, sporti dhe
                    teknologjia.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-us-section">
            <p className="about-us-text">
              Ekipi ynë përbëhet nga gazetarë, redaktorë, analistë dhe
              profesionistë të fushave të ndryshme, të cilët ndajnë të njëjtin
              pasion për gazetarinë dhe informimin e drejtë. Duke kombinuar
              përvojën me inovacionin, ne krijojmë përmbajtje që pasqyron
              realitetin dhe i shërben interesit publik.
            </p>
          </div>

          <div className="about-us-section">
            <h2 className="about-us-subtitle">
              Misioni ynë është i thjeshtë por i fuqishëm:
            </h2>
            <div className="mission-highlight">
              <p className="mission-text">
                Të informojmë, të inspirojmë dhe të lidhim shqiptarët kudo që
                ndodhen.
              </p>
            </div>
          </div>

          <div className="about-us-section about-us-final">
            <div className="tagline-container">
              <p className="about-us-tagline">
                <strong>Balotazhi – Zëri i lajmit të vërtetë.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AboutUs;
